// 1. React and core dependencies
import React from 'react';

// 2. State management
import { useSelector } from 'react-redux';

// 3. UI components
import { Row, Col } from 'react-bootstrap';

// 4. Custom form components
import InputTextArea from '../../../../components/form-elements/InputTextArea';

const Footer = ({ values, setValues, responseTime = '', warning = '', footer = '' }) => {
  // - Global State from Store.js form Values
  const { generalData } = useSelector((state) => state.general_data);
  return (
    <Row className={`g-3 my-5 ${generalData.fields.isVerifiedToReport ? 'd-flex' : 'd-none'}`}>
      <Col className="mb-5">
        <InputTextArea
          value={values.comment}
          label="¿Tienes algún comentario adicional?"
          formObj={setValues}
          fieldName="comment"
          validation={/^[A-Z0-9 ]+$/i}
        />
        {/* responseTime = al campo descripcion del admin api */}
        <div className="mx-auto my-5 text-center text-primary" style={{ maxWidth: '800px' }}>
          {responseTime}
        </div>
        <div className="mx-auto my-5 text-center text-alternate" style={{ maxWidth: '800px' }}>
          {warning}
        </div>

        <div className="text-medium mx-auto text-center text-alternate">
          {footer}
          {/* IMPORTANTE: TODO REPORTE DE INCIDENCIA DE GUÍAS GENERADAS A TRAVÉS DE NUESTRA PLATAFORMA, DEBE SER INFORMADO A NUESTRA ÁREA DE SOPORTE LOGÍSTICO, EL
          SEGUIMIENTO SE LE NOTIFICARÁ MEDIANTE NUESTRO PERSONAL. */}
        </div>
      </Col>
    </Row>
  );
};

export default Footer;
